export default {
  path: '/profile_tools',
  name: 'profile_tools',
  component: () => import('../components/profiletool/Layout'),
  redirect: { name: 'ProfileToolList' },
  meta: {
    breadcrumb: 'profile.score.tools',
  },
  children: [
    {
      name: 'ProfileToolList',
      path: '',
      component: () => import('../views/profiletool/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProfileToolCreate',
      path: 'new',
      component: () => import('../views/profiletool/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProfileToolUpdate',
      path: ':id/edit',
      component: () => import('../views/profiletool/Update'),
      meta: {
        breadcrumb: 'profile.score.tool',
      },
    },
    {
      name: 'ProfileToolShow',
      path: ':id',
      component: () => import('../views/profiletool/Show'),
      meta: {
        breadcrumb: 'profile.score.tool',
      },
    }
  ]
};
